// ╭────────────────────────────────────────────────────────────────────────────────────╮
// ┊  This file was automatically generated
// ┊  Please do not modify manually
// ┊  ©gl it 2024 - http://www.gl-it.ch
// ╰────────────────────────────────────────────────────────────────────────────────────╯

import { IJSONSchema } from '@glittr/frontend-core/src/plugins/validation/IJSONSchema';

const schema = {
  $id: '/access-token-schema',
  type: 'object',
  required: [],
  properties: {
    token: {
      type: 'string',
      nullable: true,
    },
    expiresOn: {
      type: 'string',
      format: 'date-time',
    },
  },
} as IJSONSchema;

export default schema;
